import { createContext, useContext } from "react";

import { type NodeWitOutputModel } from "../../../../Common/hooks/useReferenceableNodes";

export type { NodeWitOutputModel };

export type ReferencedFieldContextValue = {
  referenceableNodes: NodeWitOutputModel[];
  values: unknown;
};

export const ReferencedFieldContext = createContext<ReferencedFieldContextValue>({
  referenceableNodes: [],
  values: undefined,
});

export function useReferencedFieldContext() {
  return useContext(ReferencedFieldContext);
}
